// Translations for Ultimate Texas Hold'em
// Supports: English (en), French (fr), German (de)

export const translations = {
  en: {
    // Header
    title: "ULTIMATE TEXAS HOLD'EM",
    subtitle: "PREMIUM CASINO EXPERIENCE",
    signUp: "Sign Up",
    login: "Login",
    moreGames: "More Games",
    
    // Game phases
    deal: "DEAL",
    check: "CHECK",
    fold: "FOLD",
    bet: "BET",
    newHand: "NEW HAND",
    revealing: "Revealing...",
    
    // Card labels
    communityCards: "COMMUNITY CARDS",
    dealerHand: "DEALER",
    yourHand: "YOUR HAND",
    highCard: "High Card",
    pair: "Pair",
    
    // Chips
    trips: "TRIPS",
    ante: "ANTE",
    blind: "BLIND",
    play: "PLAY",
    totalBet: "Total Bet",
    
    // Results
    winner: "WINNER!",
    dealerWins: "DEALER WINS",
    push: "PUSH",
    folded: "FOLDED",
    win: "WIN",
    lose: "LOSE",
    goodFold: "GOOD FOLD!",
    badFold: "BAD FOLD",
    foldPush: "FOLD (TIE)",
    dealerWouldWin: "Dealer would have won",
    wouldHaveTied: "Would have been a tie",
    youWouldWin: "You would have won!",
    
    // Sidebar
    yourBalance: "YOUR BALANCE",
    reset: "Reset",
    handsPlayed: "HANDS PLAYED",
    today: "TODAY",
    viewStats: "View Stats",
    
    // Payout tables
    tripsPayout: "TRIPS BONUS",
    blindPayout: "BLIND PAYOUT",
    royalFlush: "ROYAL FLUSH",
    straightFlush: "STRAIGHT FLUSH",
    fourOfAKind: "FOUR OF A KIND",
    fullHouse: "FULL HOUSE",
    flush: "FLUSH",
    straight: "STRAIGHT",
    threeOfAKind: "THREE OF A KIND",
    otherHands: "OTHER HANDS",
    
    // Settings
    advice: "Advice",
    sound: "Sound",
    changeDeck: "Change Deck",
    
    // Messages
    placeBets: "Place your bets and hit DEAL",
    antePushes: "Ante pushes if dealer has less than a pair",
    notEnoughMoney: "Not enough money!",
    clickToEdit: "Click to edit",
    
    // Game explanation
    gameExplanation: "Beat the dealer with the best 5-card poker hand! Place your Ante & Blind, get 2 cards, then bet 4x/3x/2x/1x or check as community cards are revealed. Dealer needs a pair to qualify.",
    howToPlay: "How to play",
    
    // Advice
    strongPair: "STRONG PAIR - BET 4X!",
    mediumPair: "PAIR - BET 3X/4X",
    aceSuited: "ACE SUITED - BET 4X!",
    strongAce: "STRONG ACE - BET 4X",
    aceHigh: "ACE HIGH - BET 3X OR CHECK",
    kingSuited: "KING SUITED - BET 3X",
    weakHand: "WEAK HAND - CHECK",
    strongHand: "STRONG - BET 2X!",
    madeHand: "MADE HAND - BET 2X OR CHECK",
    weakCheck: "WEAK - CHECK",
    madeHandBet: "MADE HAND - BET 1X",
    considerFolding: "WEAK - CONSIDER FOLDING",
    
    // Recent wins
    recentJackpots: "RECENT JACKPOTS",
    playersOnline: "Players Online",
    minAgo: "min ago",
    
    // Modals
    statistics: "STATISTICS",
    achievements: "ACHIEVEMENTS",
    stats: "STATS",
    overview: "OVERVIEW",
    byHand: "BY HAND",
    byBet: "BY BET",
    netWinnings: "NET WINNINGS",
    goodFolds: "GOOD FOLDS",
    tripsWins: "TRIPS WINS",
    blindBonuses: "BLIND BONUSES",
    handTypeStats: "Wins & Losses by Hand Type",
    betTypeStats: "Performance by Bet Timing",
    bestHand: "Best Hand",
    preflop4x: "Pre-flop 4X",
    preflop3x: "Pre-flop 3X",
    flop2x: "Flop 2X",
    river1x: "River 1X",
    wins: "Wins",
    losses: "Losses",
    winRate: "win rate",
    tip: "Tip",
    optimalPlayTip: "Optimal play: Bet 4X with strong pairs and suited aces. Never fold before the river!",
    allTime: "ALL TIME",
    reloadChips: "RELOAD CHIPS",
    selectBuyIn: "Select your buy-in amount",
    customAmount: "CUSTOM AMOUNT",
    confirm: "CONFIRM",
    cancel: "Cancel",
    welcomeBack: "WELCOME BACK",
    joinTable: "JOIN THE TABLE",
    recoverAccount: "RECOVER ACCOUNT",
    username: "USERNAME",
    password: "PASSWORD",
    forgotPassword: "Forgot Password?",
    noAccount: "Don't have an account?",
    haveAccount: "Already have an account?",
    backToLogin: "Back to Login",
    selectDeckStyle: "SELECT DECK STYLE",
    classicRed: "Classic Red",
    royalBlue: "Royal Blue",
    midnightBlack: "Midnight Black",
    apply: "Apply",
    
    // SEO
    metaTitle: "Ultimate Texas Hold'em - Free Online Casino Poker Game",
    metaDescription: "Play Ultimate Texas Hold'em for free online. Practice your poker strategy against the dealer with virtual chips. No download required!",
    metaKeywords: "ultimate texas holdem, poker, casino game, free poker, online poker, texas holdem, card game",
  },
  
  fr: {
    // Header
    title: "ULTIMATE TEXAS HOLD'EM",
    subtitle: "EXPÉRIENCE CASINO PREMIUM",
    signUp: "S'inscrire",
    login: "Connexion",
    moreGames: "Plus de Jeux",
    
    // Game phases
    deal: "DISTRIBUER",
    check: "PAROLE",
    fold: "SE COUCHER",
    bet: "MISER",
    newHand: "NOUVELLE MAIN",
    revealing: "Révélation...",
    
    // Card labels
    communityCards: "CARTES COMMUNES",
    dealerHand: "CROUPIER",
    yourHand: "VOTRE MAIN",
    highCard: "Carte Haute",
    pair: "Paire",
    
    // Chips
    trips: "TRIPS",
    ante: "ANTE",
    blind: "BLIND",
    play: "PLAY",
    totalBet: "Mise Totale",
    
    // Results
    winner: "GAGNANT !",
    dealerWins: "LE CROUPIER GAGNE",
    push: "ÉGALITÉ",
    folded: "COUCHÉ",
    win: "GAGNÉ",
    lose: "PERDU",
    goodFold: "BON FOLD !",
    badFold: "MAUVAIS FOLD",
    foldPush: "FOLD (ÉGALITÉ)",
    dealerWouldWin: "Le croupier aurait gagné",
    wouldHaveTied: "Ça aurait été égalité",
    youWouldWin: "Vous auriez gagné !",
    
    // Sidebar
    yourBalance: "VOTRE SOLDE",
    reset: "Réinitialiser",
    handsPlayed: "MAINS JOUÉES",
    today: "AUJOURD'HUI",
    viewStats: "Voir Stats",
    
    // Payout tables
    tripsPayout: "BONUS TRIPS",
    blindPayout: "PAIEMENT BLIND",
    royalFlush: "QUINTE FLUSH ROYALE",
    straightFlush: "QUINTE FLUSH",
    fourOfAKind: "CARRÉ",
    fullHouse: "FULL",
    flush: "COULEUR",
    straight: "SUITE",
    threeOfAKind: "BRELAN",
    otherHands: "AUTRES MAINS",
    
    // Settings
    advice: "Conseils",
    sound: "Son",
    changeDeck: "Changer Jeu",
    
    // Messages
    placeBets: "Placez vos mises et appuyez sur DISTRIBUER",
    antePushes: "L'Ante est remboursé si le croupier n'a pas au moins une paire",
    notEnoughMoney: "Pas assez d'argent !",
    clickToEdit: "Cliquez pour modifier",
    
    // Game explanation
    gameExplanation: "Battez le croupier avec la meilleure main de 5 cartes ! Placez votre Ante & Blind, recevez 2 cartes, puis misez 4x/3x/2x/1x ou parole au fur et à mesure que les cartes communes sont révélées. Le croupier doit avoir une paire pour qualifier.",
    howToPlay: "Comment jouer",
    
    // Advice
    strongPair: "GROSSE PAIRE - MISEZ 4X !",
    mediumPair: "PAIRE - MISEZ 3X/4X",
    aceSuited: "AS ASSORTI - MISEZ 4X !",
    strongAce: "AS FORT - MISEZ 4X",
    aceHigh: "AS HAUT - MISEZ 3X OU PAROLE",
    kingSuited: "ROI ASSORTI - MISEZ 3X",
    weakHand: "MAIN FAIBLE - PAROLE",
    strongHand: "MAIN FORTE - MISEZ 2X !",
    madeHand: "MAIN FAITE - MISEZ 2X OU PAROLE",
    weakCheck: "FAIBLE - PAROLE",
    madeHandBet: "MAIN FAITE - MISEZ 1X",
    considerFolding: "FAIBLE - ENVISAGEZ DE VOUS COUCHER",
    
    // Recent wins
    recentJackpots: "JACKPOTS RÉCENTS",
    playersOnline: "Joueurs en Ligne",
    minAgo: "min",
    
    // Modals
    statistics: "STATISTIQUES",
    achievements: "SUCCÈS",
    stats: "STATS",
    overview: "APERÇU",
    byHand: "PAR MAIN",
    byBet: "PAR MISE",
    netWinnings: "GAINS NETS",
    goodFolds: "BONS FOLDS",
    tripsWins: "GAINS TRIPS",
    blindBonuses: "BONUS BLIND",
    handTypeStats: "Gains et Pertes par Type de Main",
    betTypeStats: "Performance par Timing de Mise",
    bestHand: "Meilleure Main",
    preflop4x: "Pré-flop 4X",
    preflop3x: "Pré-flop 3X",
    flop2x: "Flop 2X",
    river1x: "River 1X",
    wins: "Gains",
    losses: "Pertes",
    winRate: "taux de victoire",
    tip: "Conseil",
    optimalPlayTip: "Jeu optimal : Misez 4X avec des paires fortes et des as assortis. Ne vous couchez jamais avant la river !",
    allTime: "TOUT TEMPS",
    reloadChips: "RECHARGER JETONS",
    selectBuyIn: "Sélectionnez votre mise de départ",
    customAmount: "MONTANT PERSONNALISÉ",
    confirm: "CONFIRMER",
    cancel: "Annuler",
    welcomeBack: "BON RETOUR",
    joinTable: "REJOINDRE LA TABLE",
    recoverAccount: "RÉCUPÉRER LE COMPTE",
    username: "NOM D'UTILISATEUR",
    password: "MOT DE PASSE",
    forgotPassword: "Mot de passe oublié ?",
    noAccount: "Pas encore de compte ?",
    haveAccount: "Déjà un compte ?",
    backToLogin: "Retour à la connexion",
    selectDeckStyle: "CHOISIR LE STYLE DE CARTES",
    classicRed: "Rouge Classique",
    royalBlue: "Bleu Royal",
    midnightBlack: "Noir Minuit",
    apply: "Appliquer",
    
    // SEO
    metaTitle: "Ultimate Texas Hold'em - Jeu de Poker Casino Gratuit en Ligne",
    metaDescription: "Jouez au Ultimate Texas Hold'em gratuitement en ligne. Entraînez votre stratégie poker contre le croupier avec des jetons virtuels. Aucun téléchargement requis !",
    metaKeywords: "ultimate texas holdem, poker, jeu casino, poker gratuit, poker en ligne, texas holdem, jeu de cartes",
  },
  
  de: {
    // Header
    title: "ULTIMATE TEXAS HOLD'EM",
    subtitle: "PREMIUM CASINO ERLEBNIS",
    signUp: "Registrieren",
    login: "Anmelden",
    moreGames: "Mehr Spiele",
    
    // Game phases
    deal: "GEBEN",
    check: "CHECKEN",
    fold: "PASSEN",
    bet: "SETZEN",
    newHand: "NEUE HAND",
    revealing: "Aufdecken...",
    
    // Card labels
    communityCards: "GEMEINSCHAFTSKARTEN",
    dealerHand: "DEALER",
    yourHand: "IHRE HAND",
    highCard: "Höchste Karte",
    pair: "Paar",
    
    // Chips
    trips: "TRIPS",
    ante: "ANTE",
    blind: "BLIND",
    play: "PLAY",
    totalBet: "Gesamteinsatz",
    
    // Results
    winner: "GEWINNER!",
    dealerWins: "DEALER GEWINNT",
    push: "UNENTSCHIEDEN",
    folded: "GEPASST",
    win: "GEWINN",
    lose: "VERLUST",
    goodFold: "GUTES FOLD!",
    badFold: "SCHLECHTES FOLD",
    foldPush: "FOLD (GLEICH)",
    dealerWouldWin: "Dealer hätte gewonnen",
    wouldHaveTied: "Wäre unentschieden gewesen",
    youWouldWin: "Sie hätten gewonnen!",
    
    // Sidebar
    yourBalance: "IHR GUTHABEN",
    reset: "Zurücksetzen",
    handsPlayed: "GESPIELTE HÄNDE",
    today: "HEUTE",
    viewStats: "Statistiken",
    
    // Payout tables
    tripsPayout: "TRIPS BONUS",
    blindPayout: "BLIND AUSZAHLUNG",
    royalFlush: "ROYAL FLUSH",
    straightFlush: "STRAIGHT FLUSH",
    fourOfAKind: "VIERLING",
    fullHouse: "FULL HOUSE",
    flush: "FLUSH",
    straight: "STRASSE",
    threeOfAKind: "DRILLING",
    otherHands: "ANDERE HÄNDE",
    
    // Settings
    advice: "Tipps",
    sound: "Ton",
    changeDeck: "Kartendeck",
    
    // Messages
    placeBets: "Setzen Sie und drücken Sie GEBEN",
    antePushes: "Ante wird zurückgezahlt wenn Dealer weniger als ein Paar hat",
    notEnoughMoney: "Nicht genug Geld!",
    clickToEdit: "Klicken zum Bearbeiten",
    
    // Game explanation
    gameExplanation: "Schlagen Sie den Dealer mit der besten 5-Karten-Pokerhand! Setzen Sie Ante & Blind, erhalten Sie 2 Karten, dann setzen Sie 4x/3x/2x/1x oder checken Sie, während die Gemeinschaftskarten aufgedeckt werden. Der Dealer braucht ein Paar zum Qualifizieren.",
    howToPlay: "Spielanleitung",
    
    // Advice
    strongPair: "STARKES PAAR - 4X SETZEN!",
    mediumPair: "PAAR - 3X/4X SETZEN",
    aceSuited: "ASS SUITED - 4X SETZEN!",
    strongAce: "STARKES ASS - 4X SETZEN",
    aceHigh: "ASS HOCH - 3X ODER CHECKEN",
    kingSuited: "KÖNIG SUITED - 3X SETZEN",
    weakHand: "SCHWACHE HAND - CHECKEN",
    strongHand: "STARK - 2X SETZEN!",
    madeHand: "GEMACHTE HAND - 2X ODER CHECKEN",
    weakCheck: "SCHWACH - CHECKEN",
    madeHandBet: "GEMACHTE HAND - 1X SETZEN",
    considerFolding: "SCHWACH - PASSEN ERWÄGEN",
    
    // Recent wins
    recentJackpots: "AKTUELLE JACKPOTS",
    playersOnline: "Spieler Online",
    minAgo: "Min",
    
    // Modals
    statistics: "STATISTIKEN",
    achievements: "ERFOLGE",
    stats: "STATS",
    overview: "ÜBERSICHT",
    byHand: "NACH HAND",
    byBet: "NACH EINSATZ",
    netWinnings: "NETTOGEWINN",
    goodFolds: "GUTE FOLDS",
    tripsWins: "TRIPS GEWINNE",
    blindBonuses: "BLIND BONI",
    handTypeStats: "Gewinne & Verluste nach Handtyp",
    betTypeStats: "Leistung nach Einsatz-Timing",
    bestHand: "Beste Hand",
    preflop4x: "Pre-flop 4X",
    preflop3x: "Pre-flop 3X",
    flop2x: "Flop 2X",
    river1x: "River 1X",
    wins: "Gewinne",
    losses: "Verluste",
    winRate: "Gewinnrate",
    tip: "Tipp",
    optimalPlayTip: "Optimales Spiel: Setzen Sie 4X mit starken Paaren und suited Assen. Passen Sie nie vor dem River!",
    allTime: "GESAMT",
    reloadChips: "CHIPS AUFLADEN",
    selectBuyIn: "Wählen Sie Ihren Buy-in Betrag",
    customAmount: "EIGENER BETRAG",
    confirm: "BESTÄTIGEN",
    cancel: "Abbrechen",
    welcomeBack: "WILLKOMMEN ZURÜCK",
    joinTable: "TISCH BEITRETEN",
    recoverAccount: "KONTO WIEDERHERSTELLEN",
    username: "BENUTZERNAME",
    password: "PASSWORT",
    forgotPassword: "Passwort vergessen?",
    noAccount: "Noch kein Konto?",
    haveAccount: "Bereits ein Konto?",
    backToLogin: "Zurück zur Anmeldung",
    selectDeckStyle: "KARTENSTIL WÄHLEN",
    classicRed: "Klassisch Rot",
    royalBlue: "Königsblau",
    midnightBlack: "Mitternachtsschwarz",
    apply: "Anwenden",
    
    // SEO
    metaTitle: "Ultimate Texas Hold'em - Kostenloses Online Casino Pokerspiel",
    metaDescription: "Spielen Sie Ultimate Texas Hold'em kostenlos online. Üben Sie Ihre Pokerstrategie gegen den Dealer mit virtuellen Chips. Kein Download erforderlich!",
    metaKeywords: "ultimate texas holdem, poker, casinospiel, gratis poker, online poker, texas holdem, kartenspiel",
  }
};

export const getTranslation = (lang, key) => {
  return translations[lang]?.[key] || translations['en'][key] || key;
};

export const supportedLanguages = [
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
];
